import { z } from 'zod'

export const InteractionSchema = z.object({
  id: z.string().uuid().optional(),
  captured_at: z.number().finite().nonnegative().optional(),
  source_timestamp: z.number().nonnegative(),
  kind: z.enum(['click', 'change', 'input', 'paste', 'keydown', 'keyup']),
  selector: z.string().min(1).max(2_000).nullable(),
  label: z.string().min(1).max(500).nullable(),
  tag_name: z.string().optional(),
  value: z.string().optional(),
  text: z.string().optional(),
  key: z.string().optional(),
  code: z.string().optional(),
  inputType: z.string().optional(),
  altKey: z.boolean().optional(),
  ctrlKey: z.boolean().optional(),
  metaKey: z.boolean().optional(),
  shiftKey: z.boolean().optional(),
  repeat: z.boolean().optional(),
  isComposing: z.boolean().optional(),

})
